import { useState, useEffect } from "react"
import { Source, Layer } from "react-map-gl/mapbox"
import type { FeatureCollection } from "geojson"
import type { ICommune } from "@/types/explore"

interface HeatNetworkLayerProps {
  commune?: ICommune
}

const EMPTY_FC: FeatureCollection = { type: "FeatureCollection", features: [] }

export const HeatNetworkLayer = ({ commune }: HeatNetworkLayerProps) => {
  const [geoJson, setGeoJson] = useState<FeatureCollection>(EMPTY_FC)

  useEffect(() => {
    if (!commune?.code) return
    let cancelled = false
    fetch(`/api/explore/heat-network?code=${commune.code}`)
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled) {
          setGeoJson({
            type: "FeatureCollection",
            features: Array.isArray(data) ? data : [],
          })
        }
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [commune?.code])

  if (geoJson.features.length === 0) return null

  return (
    <Source id="heat-network" type="geojson" data={geoJson}>
      <Layer
        id="heat-network"
        type="line"
        paint={{
          "line-color": "#46A097",
          "line-width": 3,
        }}
      />
    </Source>
  )
}
